import React from 'react';
import { createRoot } from 'react-dom/client';
import 'src/utils/dayjs'; // configura dayjs (plugins, locale es, tz Mexico_City)
import * as serviceWorker from './serviceWorker';
import App from './App';

import './i18n';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(<App />);

serviceWorker.unregister();
